import { api } from '../api';

export const authService = {
  async login(credentials) {
    return api.post('login', credentials);
  },

  async recovery(credentials) {
    return api.post('login/recovery', credentials);
  },

  async changePassword(params) {
    return api.post('login/recovery/change-password', params);
  },

  async checkLogin() {
    return api.get('user');
  },

  async checkNotifications() {
    return api.get('user/notifications');
  },

  async register(userData) {
    return api.post('register', userData);
  },

  async logout() {
    return api.get('logout');
  },

  async getInvitation(code) {
    return api.get(`invitation/${code}`);
  },

  async registerInvitation(userData) {
    return api.post('invitation/register', userData);
  },
};